export const getAbsoluteAssetLink = assetLink =>
    window.location.hostname === 'localhost' ? assetLink : `${window.location.origin}/resources${assetLink}`;
